
import { ArrowBackOutlined } from "@mui/icons-material";
import { Button, Grid, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { ERoute } from "../constants";
import Logo from "./Logo";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const hasBackButton = !["", "home"]
    .map((route) => "/" + route)
    .includes(location.pathname);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Grid
      item
      container
      bgcolor="#7C0612"
      display="flex"
      direction="row"
      alignItems="center"
      justifyContent="center"
      height={120}
    >
      {hasBackButton && (
        <Grid item position="absolute" left={20}>
          <Button
            startIcon={<ArrowBackOutlined />}
            onClick={handleBack}
            variant="contained"
            sx={{
              color: "black",
              backgroundColor: "white",
              borderRadius: "20px",
              padding: "0.2rem 1.5rem",
              textTransform: "capitalize",
            }}
          >
            <Typography variant="body1" color="black">
              Back
            </Typography>
          </Button>
        </Grid>
      )}
      <Grid
        container
        item
        direction="column"
        wrap="nowrap"
        justifyContent="center"
        alignItems="center"
        onClick={() => navigate("/" + ERoute.HOME)}
        sx={{ cursor: "pointer" }}
      >
        <Logo width="50" height="50" />
        <Typography>Home</Typography>
      </Grid>
      {/* {hasVolumeControl && (
        <Grid item position="absolute" right={20}>
          <VideoController />
        </Grid>
      )} */}
    </Grid>
  );
};

export default Header;
